import axios from 'axios';
import { z } from 'zod';

const projectRoleRefusalSchema = z.object({
  code: z.literal('project_role_not_assignable'),
  details: z.object({ roleName: z.string() }),
});

/**
 * The role the server refused because it holds permissions the caller lacks; `undefined`
 * for any other failure, which the caller reports as it always has.
 */
export function readProjectRoleRefusal(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) return undefined;
  const parsed = projectRoleRefusalSchema.safeParse(error.response?.data);
  return parsed.success ? parsed.data.details.roleName : undefined;
}
